import {FC} from 'react'
import {List, ListHeader, ListItem, ListArrow, AlertLink, Indicator} from './List'
import {ContractAlertEmployee} from './query'

interface ContractAlertsProps {
  employees: ContractAlertEmployee[]
}

export const ContractAlerts: FC<ContractAlertsProps> = ({employees}) => {
  if (employees.length === 0) {
    return null
  }

  return (
    <div>
      <ListHeader>契約更新が必要な従業員がいます</ListHeader>
      <List>
        {employees.map((employee) => (
          <ListItem key={employee.id}>
            <AlertLink to={`/employees/${employee.id}/edit#EmploymentInfomation`}>
              <Indicator />
              {employee.displayFullName}
              <ListArrow />
            </AlertLink>
          </ListItem>
        ))}
      </List>
    </div>
  )
}
